import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { fetchReviewEntryDetail } from '../query-api'
import type { ReviewEntryDetail } from '../types/reviewEntryDetail'

interface UseFetchReviewEntryAiReasoningResult {
  isLoading: boolean
  reasoning: string | null
}

export const useFetchReviewEntryAiReasoning = (documentId?: string): UseFetchReviewEntryAiReasoningResult => {
  const { organization } = useUserOrganization()
  const organizationId = organization?.id

  const queryParams = useMemo(
    () => ({ documentId: documentId as string, organizationId: organizationId as string }),
    [documentId, organizationId],
  )

  const { data, isLoading } = useQuery<ReviewEntryDetail>(
    [QueryKeys.ReviewEntryDetail, queryParams],
    () => fetchReviewEntryDetail(queryParams),
    {
      enabled: !!organizationId && !!documentId,
      staleTime: defaultStaleTime,
    },
  )

  const reasoning = data?.processingDecision?.synthesis?.reasoning?.trim() || null

  return { isLoading, reasoning }
}
